import React, { useContext, useState } from 'react'
import Modal from '../../components/Modal/Modal';
import { useForm } from 'react-hook-form';
import { errorToast, successToast } from '../../utils/notificationUtils';
import SettingHandler from '../../Apihander/setting/settingHandler';
import SidebarContext from '../../contexts/MyContext';
import '../../css/login.css'
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();
    const [loading, setLoading] = useState(false)
    const { setOpenForgotPasswordModal } = useContext(SidebarContext);


    const handleForgotPasword = async (payload) => {
        try {
            setLoading(true)
            const data = await SettingHandler.doHandlerForgotPassword(payload)
            if (data?.success === true) {
                successToast(data?.message)
                setLoading(false)
                setOpenForgotPasswordModal(false)
                reset()
                navigate('/')
            } else {
                const errorMessage =
                    data?.response?.data?.error || data?.error || "An error occurred";
                errorToast(errorMessage)
                setLoading(false)
            }
        } catch (error) {

            console.log('Error on Contact :', error)
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            errorToast(errorMessage);
            setLoading(false)
        }
    }
    return (
        <>
            <section className="">
                <div className="container-fluid h-custom">
                    <div
                        className="modal d-block"
                        style={{ background: "#0000009e" }}
                        tabIndex="-1"
                    >
                        <div
                            className="modal-dialog modal-dialog-centered custom-modal-login d-flex justify-content-center"
                        >
                            <div className="modal-content rounded-lg" style={{ borderRadius: '20px', width: '80%' }}>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-12">
                                            <div className="main-text" style={{marginLeft:'24px'}}>
                                                <p className="text-md main-heading-login">
                                                    Forgot Password
                                                </p>
                                                <p className="sub-heading-login">
                                                    Enter Your email addreass You Use to Sign in to Voice Recorder and we send you a link to reset your password.
                                                </p>
                                            </div>

                                            <div className=" d-flex justify-content-center text-center" style={{ padding: '44px 0px' }}>
                                                <form onSubmit={handleSubmit(handleForgotPasword)}
                                                    noValidate
                                                >
                                                    <div className="row text-left">
                                                        <div className="form-group col-sm-12 col-md-12 flex-column d-flex">
                                                            <input type="email" id="email" name="email" placeholder="Enter your email"
                                                                className={`form-control custom-input-field ${errors.email ? 'error' : ''}`}
                                                                style={{ padding: '16px 16px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                                                {...register("email", {
                                                                    required: 'Email address is required',
                                                                    pattern: {
                                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                                        message: 'Enter a valid email address'
                                                                    }

                                                                })} />
                                                            {errors.email && <span className="error-message" style={{ textAlign: "start" }}>{errors.email.message}</span>}
                                                        </div>
                                                    </div>

                                                    <div className="row justify-content-center my-4" style={{ alignItems: 'center' }}>
                                                        <div className="form-group">
                                                            <button type='submit' className='btn-submit'
                                                                disabled={loading}>
                                                                {loading ? (
                                                                    <>
                                                                        <div
                                                                            className="spinner-border"
                                                                            role="status"
                                                                            style={{ width: "1.5rem", height: "1.5rem" }}
                                                                        >
                                                                            <span className="visually-hidden">Loading...</span>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <span style={{ fontFamily: 'Metropolis', fontWeight: '700', font: '16px', lineHeight: '20px', }}>Submit</span>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 position-relative">
                                            <div className="d-flex align-item-end justify-content-end">
                                                <button
                                                    type="button"
                                                    className="close-btn"
                                                    onClick={() => {
                                                        { setOpenForgotPasswordModal(false); reset() }
                                                    }
                                                    }
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    style={{
                                                        background: loading ? "#d1d5db" : "#F1F5F9",
                                                        color: loading ? "#9ca3af" : "#94A3B8",
                                                        cursor: loading ? "not-allowed" : "pointer"
                                                    }}
                                                >
                                                    <span aria-hidden="true">&times;</span>

                                                </button>
                                            </div>
                                            <div className="d-none d-sm-flex img-login-main">
                                                <img
                                                    src="/img/login/signup.png"
                                                    alt="signup"
                                                    className="img-login"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

        </>



    )
}

export default ForgotPassword
